import React from 'react';
import memoizeOne from 'memoize-one';
import withFireUiAnalytics from '@atlassian/jira-analytics-web-react/src/components/with-fire-ui-analytics.tsx';
import FilterSearch from '@atlassian/jira-common-analytics-v2-wrapped-components/src/filter-search.tsx';
import type { FilterViewProps } from '@atlassian/jira-directory-base/src/model/index.tsx';
import ProjectPicker from '@atlassian/jira-project-picker/src/index.tsx';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import type { Filter as FilterType } from '../../../model/index.tsx';
import { getBaseUrl } from '../../../state/selectors/app/index.tsx';
import {
	getFilter,
	getSelectedProject,
	getSearchText,
} from '../../../state/selectors/query/index.tsx';
import type { State } from '../../../state/types.tsx';
import type { FilterSearchProps, ProjectSearchProps } from './types.tsx';
import Filter from './view.tsx';

const FilterSearchWithAnalytics = withFireUiAnalytics({
	onChange: 'filterSearch',
})(FilterSearch);
const ProjectTypePickerWithAnalytics = withFireUiAnalytics({
	onChange: 'projectSearch',
})(ProjectPicker);

const renderFilterSearch = (state: State) => (props: FilterSearchProps) => (
	<FilterSearchWithAnalytics {...props} value={getSearchText(state)} />
);

const renderProjectPicker = (state: State) => (props: ProjectSearchProps) => (
	/* @ts-expect-error - Type '{ selectedProject: Project | undefined; baseUrl: string; inputId: string; label?: string | undefined; width?: string | undefined; isDisabled?: boolean | undefined; placeholder?: string | undefined; ... 6 more ...; onChange: (arg1: Project, arg2: UIAnalyticsEvent) => void; }' is not assignable to type 'Omit<{ onChange: (arg1: Project | undefined, args_1: UIAnalyticsEvent) => void; baseUrl: string; placeholder?: string | undefined; selectedProject: Project | undefined; ... 10 more ...; forwardedRef?: Ref<...> | undefined; }, keyof WithAnalyticsEventsProps>'. */
	<ProjectTypePickerWithAnalytics
		{...props}
		selectedProject={getSelectedProject(state)}
		baseUrl={getBaseUrl(state)}
		inputId="board-filters-project-picker-select"
	/>
);

const mapStateToPropsFactory = () => {
	const renderFilterSearchFactory = memoizeOne(renderFilterSearch);
	const renderProjectPickerFactory = memoizeOne(renderProjectPicker);
	return (state: State, ownProps: FilterViewProps<FilterType>) => ({
		value: getFilter(state),
		onChange: ownProps.onFilter,
		renderFilterSearch: renderFilterSearchFactory(state),
		renderProjectPicker: renderProjectPickerFactory(state),
	});
};

export default connect(mapStateToPropsFactory, {})(Filter);
